import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { usePlanMainTarget } from "./hooks";

export const QuestionMainTarget = memo(() => {
	const { mainTarget, onSetMainTarget } = usePlanMainTarget();

	const onChange = (value: string) => {
		onSetMainTarget(value);
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"メインターゲット"}
			guide="ゲストが予約する際にプランと合わせて表示される文章です。どんな人に向けたプランなのかをわかりやすく表現しましょう。"
			isEdited={mainTarget?.isEdited ?? false}
			hasError={Boolean(mainTarget?.error)}
			inputChildren={
				<InputTextField
					type="text"
					errorMessage={mainTarget?.error}
					placeholder="例) 記念日をパートナーと一緒に祝いたい人・貸切サウナでデトックスしたい人"
					value={mainTarget?.value ?? undefined}
					handleChange={onChange}
				/>
			}
		/>
	);
});

QuestionMainTarget.displayName = "QuestionMainTarget";
